export default "__VITE_ASSET__SYIIRVTB__"